import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import {
  DateValidator,
  MaskManager,
  MunicipioModel,
  MunicipioService,
  NotaFiscalService,
  NotaFiscalViewModel,
  UtilHelper,
} from '../../../shared';
import { ConsumidorModel } from '../../consumidor/shared/consumidor.model';
import { ConsumidorService } from '../../consumidor/shared/consumidor.service';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { Navegador } from '../../../shared/navegador/navegador';
import { DownloadAutomatico } from '../../../shared/arquivo/download-automatico';
import { FiltroRelatorioNotasFiscaisCidadao } from '../../../shared/filter/filtro-relatorio-notas-fiscais-cidadao';
import { TipoExportacao } from '../../../shared/filter/enum-tipo-exportacao';

@Component({
  selector: 'app-consumidor-notas',
  templateUrl: './consumidor-notas.component.html',
  styleUrls: ['./consumidor-notas.component.css']
})
export class ConsumidorNotasComponent implements OnInit {
  public formErrors = {
    'dateGroup.dataInicial': '',
    'dateGroup.dataFinal': '',
    municipioId: '',
    dateGroup: ''
  };

  public validationMessages = {
    'dateGroup.dataInicial': {
      brazilianDate: 'Data Inicial inválida. Informe uma Data Inicial válida.',
      dataInvalida: 'O campo Data Inicial não pode ser maior que a data atual.'
    },
    'dateGroup.dataFinal': {
      brazilianDate: 'Data Final inválida. Informe uma Data Final válida.',
      dataInvalida: 'O campo Data Final não pode ser maior que a data atual.'
    },
    dateGroup: {
      periodoInvalido: 'O campo Data Inicial não pode ser maior que a data final.'
    }
  };

  private MensagemNaoExportacao : string = "Não foram encontrados registros para a geração do relatório.";
  private MensagemNaoDownloadArquivo: string = "Não foi possível realizar o download do arquivo solicitado.";

  public pagina = 1;
  private tamanhoPagina = 10;

  public tipoExportacao: typeof TipoExportacao = TipoExportacao;

  public notasFiscais: NotaFiscalViewModel[];
  public municipios: MunicipioModel[];
  public inscreverNotas: Subscription;
  public filtroNotasFiscaisForm: FormGroup;
  public notificacao = 'Nenhuma nota foi encontrada para os parâmetros pesquisados.';
  public campos = 'Informe pelo menos um dos campos: Data inicial, Data final ou Município.';
  public periodoDataInvalida = 'Período inválido. A data inicial é maior que a data final.';
  public semRegistros = false;
  public validarForm = true;
  public validarFormPeriodoData = true;
  public maskData = MaskManager.DATA;
  public maskDataPadrao = 'YYYY-MM-DD';
  public readonly maskDataVisual = 'DD/MM/YYYY';

  public MensagemErro: string;

  private cpf = null;

  constructor(
    private readonly municipioService: MunicipioService,
    private readonly notasFiscaisService: NotaFiscalService,
    private readonly consumidorService: ConsumidorService
  ) {}

  ngOnInit() {
    const consumidor: ConsumidorModel = this.consumidorService.getConsumidorModel();

    const cadastroPessoaFisica = `${UtilHelper.lpad(consumidor.cpfBase.toString(), 9)}${UtilHelper.lpad(
      consumidor.cpfDigito.toString(),
      2
    )}`;

    this.notasFiscaisService.cpf = cadastroPessoaFisica;
    this.cpf = cadastroPessoaFisica;

    this.filtroNotasFiscaisForm = new FormGroup({
      criterio: new FormControl(1),
      dateGroup: new FormGroup(
        {
          dataInicial: new FormControl('', [DateValidator.validatorRegularDate.bind(this)]),
          dataFinal: new FormControl('', [DateValidator.validatorRegularDate.bind(this)])
        },
        this.dateMatchValidator.bind(this)
      ),
      municipioId: new FormControl('')
    });

    this.filtroNotasFiscaisForm.valueChanges.subscribe(data => {
      this.onValueChanged(data);
    });

    const sMunicipioService: Subscription = this.municipioService.getMunicipiosPorUF('BA').subscribe(
      data => {
        this.municipios = <MunicipioModel[]>data;
      },
      erro => {

        let err = erro as StatusRequisicao;  
        this.MensagemErro = err.motivo;

        sMunicipioService.unsubscribe();
      },
      () => {
        sMunicipioService.unsubscribe();
      }
    );

    this.inscreverNotas = this.notasFiscaisService.notasFiscaisChange.subscribe(notasFiscais => {
      this.notasFiscais = notasFiscais;

      this.semRegistros = this.notasFiscais.length === 0;
    });
  }

  dateMatchValidator(g: FormGroup) {
    const dataInicial = g.controls['dataInicial'].value;
    const dataFinal = g.controls['dataFinal'].value;

    if (!g.controls['dataInicial'].valid || !g.controls['dataFinal'].valid) {
      return null;
    }

    if (!g.get('dataInicial').value || !g.get('dataFinal').value) {
      return null;
    }

    if (g.controls['dataInicial'].value.search('_') !== -1 || g.controls['dataFinal'].value.search('_') !== -1) {
      return null;
    }

    const dataInicialStr: string[] = dataInicial.toString().split('/');
    const dataFinalStr: string[] = dataFinal.toString().split('/');

    if (new Date(Number(dataInicialStr[2]), Number(dataInicialStr[1]), Number(dataInicialStr[0]))
    > new Date(Number(dataFinalStr[2]), Number(dataFinalStr[1]), Number(dataFinalStr[0]))) {
      return { periodoInvalido: true };
    }

    return null;
  }

  private LimparMensagemErro(){
    this.MensagemErro = "";
  }

  onSubmit() {

    this.LimparMensagemErro();
    
    this.pagina = 1;
    this.BuscarNotasConsumidor();
  }

  private obterDataInicial() : string{

    const formGroup = <FormGroup>this.filtroNotasFiscaisForm.controls['dateGroup'];
    const datePikerInicial = formGroup.controls['dataInicial'];
    const dataI = datePikerInicial.value.split('/');
    const dataInicialString = dataI[2] + '-' + dataI[1] + '-' + dataI[0];

    return dataInicialString;
  }

  private obterDataFinal() : string{
      const formGroup = <FormGroup>this.filtroNotasFiscaisForm.controls['dateGroup'];
      const dataFinal = formGroup.controls['dataFinal'];
      const dataF = dataFinal.value.split('/');
      const dataFinalString = dataF[2] + '-' + dataF[1] + '-' + dataF[0];

      if(dataF.length == 1)
      return "";

      return dataFinalString;
  }

private BuscarNotasConsumidor() {
  this.notasFiscais = [];

  this.semRegistros = false;

  const criterio = this.filtroNotasFiscaisForm.controls['criterio'].value;
  const formGroup = <FormGroup>this.filtroNotasFiscaisForm.controls['dateGroup'];
  const datePikerInicial = formGroup.controls['dataInicial'];
  const dataFinal = formGroup.controls['dataFinal'];
  const municipioId = this.filtroNotasFiscaisForm.controls['municipioId'].value;

  console.log(dataFinal);

  const dataF = dataFinal.value.split('/');
  const dataI = datePikerInicial.value.split('/');
  let dataFinalString = dataF[2] + '-' + dataF[1] + '-' + dataF[0];
  const dataInicialString = dataI[2] + '-' + dataI[1] + '-' + dataI[0];

  if(dataF.length == 1) {
    dataFinalString = "";
  }

  this.validarForm = this.validaForm(datePikerInicial, dataFinal, municipioId);

  this.validarFormPeriodoData = this.validarForm
    ? this.validarPeriodoData(dataInicialString, dataFinalString)
    : this.validarFormPeriodoData;
  
  if (this.validarForm && this.validarFormPeriodoData) {
    
    this.notasFiscaisService.obterNotasFiscaisParticipantes({
      cpf: this.cpf,
      tipoPesquisa: criterio,
      dataInicial: dataInicialString,
      dataFinal: dataFinalString,
      municipioId: municipioId,
      Page: this.pagina,
      PageSize: this.tamanhoPagina
    });

  }
}

  private obterFiltroDownloadRelatorio(tipoExportacao: number) : FiltroRelatorioNotasFiscaisCidadao{

    let filtro = new FiltroRelatorioNotasFiscaisCidadao();
    filtro.cpf = this.cpf;
    filtro.tipoPesquisa = this.filtroNotasFiscaisForm.controls['criterio'].value;
    filtro.municipioId = this.filtroNotasFiscaisForm.controls['municipioId'].value;
    filtro.dataInicial = this.obterDataInicial();
    filtro.dataFinal = this.obterDataFinal();
    filtro.tipoExportacao = tipoExportacao;

    return filtro;

  }

  private gridPossuiRegistros() : boolean{

    if(!this.notasFiscais)
       return false;

    if(this.notasFiscais.length == 0)
       return false;

       return true;
  }

  public DownloadRelatorioNotasFiscais(tipoExportacao: number) {

    this.LimparMensagemErro();

    if(!this.gridPossuiRegistros()){
      this.MensagemErro = this.MensagemNaoExportacao;
      return;
    }
    
    let filtro = this.obterFiltroDownloadRelatorio(tipoExportacao);

    this.notasFiscaisService.downloadRelatorioNotaFiscal(filtro).subscribe(res => {

        const nomeArquivo = res.filename.toString();

        if(Navegador.ehInternetExplorer() || Navegador.ehEdge()) {

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([res.data]), nomeArquivo);
          }

        }else {

            DownloadAutomatico.RealizarDownload(res.data, nomeArquivo);
        }

      }, error => {                
        this.MensagemErro = this.MensagemNaoDownloadArquivo;        
      });

  }

  public limparGrid(){
    this.notasFiscais = [];
  }


  pageChange(event: number): void {
    this.pagina = event;
    this.BuscarNotasConsumidor();
  }

  validarPeriodoData(dataInicial, dataFinal): boolean {
    let valid = true;
    const dataInicialValida = UtilHelper.IsDate(dataInicial, this.maskDataPadrao);
    const dataFinalValida = UtilHelper.IsDate(dataFinal, this.maskDataPadrao);

    if (dataInicialValida && dataFinalValida) {
      valid =
        UtilHelper.ParseStringToDate(dataInicial, this.maskDataPadrao, this.maskDataPadrao) <=
        UtilHelper.ParseStringToDate(dataFinal, this.maskDataPadrao, this.maskDataPadrao);
    }

    return valid;
  }
  validaForm(datePikerInicial, dataFinal, municipioId): boolean {
    if (
      (datePikerInicial.value === '' || datePikerInicial.value == null) &&
      (dataFinal.value === '' || dataFinal.value == null) &&
      municipioId === ''
    ) {
      this.semRegistros = false;
      return false;
    } else {
      return true;
    }
  }

  encaminharParaNota(notaFiscal, i) {
    window.open(`${notaFiscal.linkEspelhoNota}${notaFiscal.cod_chave_acesso}`, '_blank');
  }

  public onChangeDate($event) {

    let dataSelecionada = $event.target.value;

    if(!dataSelecionada){
      this.limparGrid();
      this.LimparMensagemErro();
    }

    if(!this.filtroNotasFiscaisForm.valid){
      this.limparGrid();
      this.LimparMensagemErro();
    }
  }

  public onChangeCriterio($event) {
    this.limparGrid();
    this.LimparMensagemErro();
  }

    public onChangeMunicipio($event) {
      this.limparGrid();
      this.LimparMensagemErro();
    }

  onValueChanged(data?: any) {
    if (!this.filtroNotasFiscaisForm) {
      return;
    }

    const form = this.filtroNotasFiscaisForm;
    for (const field in this.formErrors) {
      if (field) {
        const control = form.get(field);
        this.formErrors[field] = '';
        if (UtilHelper.validarControl(control)) {
          this.gerMessageErro(field, control.errors);
        }
      }
    }
  }

  private gerMessageErro(_field: string, _errors: ValidationErrors) {
    const messages = this.validationMessages[_field];
    for (const key in _errors) {
      if (key) {
        this.formErrors[_field] += messages[key] + ' ';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-notas/consumidor-notas.component.ts